import { useNewsQuery } from '@features/club/api/hooks';
import { ClubNews } from '@features/club/ui/ClubNews/ClubNews';

type Props = {
  className?: string;
  clubId: string;
};
export function ClubNewsWidget({ className, clubId }: Props) {
  const { data: news, hasNextPage, fetchNextPage } = useNewsQuery(clubId, 8);

  return (
    <ClubNews className={className} news={news} onLoadMore={fetchNextPage} hasMore={hasNextPage} />
  );
}
